
gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", function () {
	window.scrollTo(0, 0);
	const loadingPage = document.getElementById('loading-page');
	if (loadingPage) {
		loadingPage.style.opacity = 0;
		setTimeout(() => {
			loadingPage.style.display = 'none';
		}, 1000);
	}
	///////////// SLIDERS //////////////
	if (document.querySelector(".splide")) {
		const sliders = document.querySelectorAll(".splide");
		sliders.forEach(el => {
			const slider = new Splide(el, {
				arrows: false,
			});
			slider.mount();
		});
	}
	if (document.querySelector(".splide-small")) {
		const slidersV2 = document.querySelectorAll(".splide.splide-small");
		slidersV2.forEach(el => {
			const sliderV2 = new Splide(el, {
				pagination: false,
				padding: { left: 0, right: '20%' },
				type: 'loop',
				arrowPath: "M0 21h38l-4 6v1l6-8-6-6v1l4 5H0z"
			});
			sliderV2.mount();
		});
	}


	


	///////////// SMOOTH SCROLL //////////////
	if (document.querySelector(".container")) {
		const pageContainer = document.querySelector(".container");

		const scroller = new LocomotiveScroll({
			el: pageContainer,
			smooth: true,
			getDirection: true,
			mobile: {
				breakpoint: 0,
				smooth: true,
				getDirection: true,
			},
			tablet: {
				breakpoint: 0,
				smooth: true,
				getDirection: true,
			},
		});

		ScrollTrigger.scrollerProxy(pageContainer, {
			scrollTop(value) {
				return arguments.length ? scroller.scrollTo(value, 0, 0) : scroller.scroll.instance.scroll.y;
			},
			getBoundingClientRect() {
				return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
			},
			pinType: pageContainer.style.transform ? "transform" : "fixed",
		});

		scroller.on("scroll", ScrollTrigger.update);
		ScrollTrigger.addEventListener("refresh", () => scroller.update());


		////////////////////////////////////

		if (window.innerWidth < 576 && document.querySelector("#imgPile-text-first")) {
			document.getElementById("imgPile-text-first").classList.add("hide");
		}


		/// POPIN VIDEO
		
		if (document.querySelector(".js-popincontainer")) {
		
			// Function to handle opening the video popin
			document.body.addEventListener('click', function (e) {
				
				if (e.target.closest('.js-open-popin-video')) {
					stopAllMedia();

					e.preventDefault();
					const name = e.target.closest('.js-open-popin-video').getAttribute('data-popin');
					const popinContainer = document.querySelector('.js-popincontainer');
					const videoElement = popinContainer.querySelector('.video');
					videoElement.src = `/wp-content/themes/hds_theme/assets/video/${name}.mp4`;

					if (videoElement) {
						//play the video
						videoElement.play();
					}

					popinContainer.style.display = 'block';
					setTimeout(() => {
						popinContainer.style.opacity = 1;
					}, 10);
				}
			});

			// Function to handle closing the video popin when clicking the close button
			document.body.addEventListener('click', function (e) {
				if (e.target.closest('.js-popincontent .btn_close')) {
					const videoElement = document.querySelector('.js-popincontainer video');
					if (videoElement) {
						videoElement.pause();
						videoElement.currentTime = 0;
					}

					const popinContainer = document.querySelector('.js-popincontainer');
					popinContainer.style.opacity = 0;
					setTimeout(() => {
						popinContainer.style.display = 'none';
					}, 300);
				}
			});

			// Function to handle closing the video popin when clicking outside the popin content
			document.body.addEventListener('click', function (e) {
				if (e.target.closest('.js-popincontainer') && !e.target.closest('.video')) {
					const popinContainer = document.querySelector('.js-popincontainer');
					const videoElement = document.querySelector('.js-popincontainer video');
					popinContainer.style.opacity = 0;
					setTimeout(() => {
						popinContainer.style.display = 'none';
					}, 300);
					if (videoElement) {
						videoElement.pause();
						videoElement.currentTime = 0;
					}
				}
			});

			// Function to stop propagation when clicking inside the popin content
			document.body.addEventListener('click', function (e) {
				if (e.target.closest('.js-popincontent')) {
					e.stopPropagation();
				}
			});

		}

		if (document.querySelector(".pin-item")) {
			// Create the animation
			let animation = gsap.fromTo(".pin-wrapper",
				{ y: 0 },
				{
					y: "-100vh",
					duration: 1,
					ease: "SlowMo.ease",
					paused: true // Pause the animation initially
				}
			);

			// Add the scroll trigger for pinning and animation
			ScrollTrigger.create({
				scroller: pageContainer, // locomotive-scroll
				trigger: "#sectionPin0",
				pin: true,
				start: "top top", // start after scrolling 50vh
				end: "+=300%", // keep the section pinned for 300%
				onUpdate: (self) => {
					if (self.progress >= 0.5 && animation.progress() === 0) {
						animation.play(); // Play the animation
					} else if (self.progress <= 0.49) {
						animation.reverse()
					}
				},

			});
		}
		if (document.querySelector(".video-border-block ")) {

			const videoBlock = document.querySelector('.video-border-block')
			// quand cet element est inview ajoute la class animate 
			ScrollTrigger.create({
				scroller: pageContainer, // locomotive-scroll
				trigger: videoBlock,
				pin: true,
				start: "top top",
				end: "bottom top",
				onEnter: () => {
					document.querySelector('.border-animation').classList.add("animate")
				},
				onLeave: () => {
					document.querySelector('.border-animation').classList.remove('animate')
				}
			})
		}
		if (document.querySelector(".light-1")) {


			// Animation des cartes venant du haut à gauche
			const cards = [
				{ id: '#card1', startProps: { top: '250px', left: '25px' }, endProps: { top: '45px', left: '25px' } },
				{ id: '#card2', startProps: { top: '250px', left: '-250px' }, endProps: { top: '65px', left: '5px' } },
				{ id: '#card3', startProps: { top: '250px', left: '250px' }, endProps: { top: '25px', left: '45px' } }
			];

			cards.forEach((card, index) => {
				const element = document.querySelector(card.id);
				if (element) {
					gsap.fromTo(element, card.startProps, {
						...card.endProps,
						scrollTrigger: {
							trigger: card.id,
							scroller: pageContainer,
							start: 'top bottom',
							end: 'bottom bottom',
							scrub: true,

						}
					});
				}
			});

			const light1 = document.querySelector('.light-1');
			// Timeline pour animer light-1 et light-2 séquentiellement
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: '#card2',
					scroller: pageContainer,
					start: 'top bottom',
					end: 'bottom bottom',
					scrub: true,
				}
			});

			tl.fromTo('.light-1', {
				x: '0',
				y: '0'
			}, {
				x: '-174%',
				y: '131%'
			})
				.fromTo('.light-2', { opacity: 0 }, { opacity: 1, delay: 0.3, duration: 0.01 }, "<");

			ScrollTrigger.create({
				trigger: '#card3',
				scroller: pageContainer,
				start: 'top bottom',
				end: 'bottom bottom',
				onEnter: () => {
					gsap.fromTo('.light-1', { x: '-174%', y: '131%' }, { x: '24%', y: '131%' });
					gsap.fromTo('.light-2', { opacity: 1 }, { opacity: 0, duration: 0.01 });
				},
				onLeaveBack: () => {
					gsap.fromTo('.light-1', { x: '24%', y: '131%' }, { x: '-174%', y: '131%' });
					gsap.fromTo('.light-2', { opacity: 0 }, { opacity: 1, duration: 0.01 });
				}
			});

		}
		if (document.querySelector(".pin-wrap")) {

			if (window.innerWidth > 1024) {
				let pinWrap = document.querySelector(".pin-wrap");
				let pinWrapWidth = pinWrap.offsetWidth;
				let horizontalScrollLength = pinWrapWidth - window.innerWidth;
				// Pinning and horizontal scrolling
				gsap.to(".pin-wrap", {
					scrollTrigger: {
						scroller: pageContainer, // locomotive-scroll
						scrub: 0.5,
						trigger: "#sectionPin",
						pin: true,
						start: "top top",
						end: () => `+=${pinWrapWidth * 3}`,
					},
					x: -horizontalScrollLength,
					ease: "none",
				});
			}

		}
		if (document.querySelector(".text-image-block")) {
			const textSteps = document.querySelectorAll('.text-step');
			const imageSteps = document.querySelectorAll('.image-step');
			const totalSteps = textSteps.length;
			const container = document.getElementById('scroll-section');
			const heightToScroll = window.innerHeight * (totalSteps + 1);

			const pageContainer = document.querySelector('.container'); // Assurez-vous que .container est défini dans votre HTML

			// Épingler la section pendant le défilement
			ScrollTrigger.create({
				scroller: pageContainer,
				trigger: container,
				start: "top top",
				end: `+=${heightToScroll} - 10`,
				pin: true,
				pinSpacing: true,
				scrub: 0.5,
				onEnter: () => {
					gsap.to(document.querySelector('.bee-part-home .bee-element'), { left: '100%', duration: 6, ease: "SlowMo.ease" });
				},
				onLeaveBack: () => {
					//gsap.to(document.querySelector('.bee-part-home .bee-element'), { left: '-200px', duration: 6, ease: "SlowMo.ease" });

				}
			});

			// Initialiser les timelines pour les animations de texte et d'image
			const tlText = gsap.timeline({
				scrollTrigger: {
					scroller: pageContainer,
					trigger: container,
					start: "top top",
					end: `+=${heightToScroll}`,
					scrub: true,

				}
			});

			const tlImage = gsap.timeline({
				scrollTrigger: {
					scroller: pageContainer,
					trigger: container,
					start: "top top",
					end: `+=${heightToScroll}`,
					scrub: true,
				}
			});

			// Ajouter des animations pour chaque étape de texte
			textSteps.forEach((step, i) => {
				if (i === 0) return; // Skip the first step
				tlText.fromTo(step, { opacity: 0 }, { opacity: 1, duration: 1 }, `${i * window.innerHeight}`)
				.to(step, { opacity: 0, duration: 1 }, `${(i + 1) * window.innerHeight}`);
				// if (i !== 6) {
				// }
			});

			// Ajouter des animations pour chaque étape d'image
			imageSteps.forEach((step, i) => {
				// if (i === 0) return; // Skip the first step
				tlImage.fromTo(step, { opacity: 0 }, { opacity: 1, duration: 1 }, `${i * window.innerHeight}`)
					.to(step, { opacity: 0, duration: 1 }, `${(i + 1) * window.innerHeight}`);
			});

			// // Cas spécial pour l'étape 5 et 6
			// tlText.fromTo('#step6', { opacity: 0 }, { opacity: 1, duration: 1 }, `400vh`)
			// 	.to('#step6', { opacity: 0, duration: 1 }, `500vh`);

			const imageFolder = '/wp-content/themes/hds_theme/assets/video/abeille/';
		    const imageCount = 73; // Remplacez par le nombre total d'images
		    let currentIndex = 10;
		    const images = [];
		    const imageDuration = 50; // Durée d'affichage de chaque image en millisecondes
		    const pauseDuration = 2500; // Pause après la séquence en millisecondes

		    for (let i = 10; i <= imageCount; i++) {
        		const img = new Image();
        		img.src = `${imageFolder}Abeille_VOL_Traverse_V2_000${i}-min.png`;
        		images.push(img);
    		}
		    function changeImage() {
		        document.getElementById('current-image').src = imageFolder + 'Abeille_VOL_Traverse_V2_000' + currentIndex + '-min.png';
		    	currentIndex++;

        		if (currentIndex > imageCount) {
            		currentIndex = 10;
            		clearInterval(intervalId);
            		setTimeout(startSequence, pauseDuration);
        		}
    		}
			function startSequence() {
        		intervalId = setInterval(changeImage, imageDuration);
    		}

    		let intervalId = setInterval(changeImage, imageDuration);

		}

		if (document.querySelector('.slider-seasons')) {

			const imagesSeason = document.querySelectorAll('.img-season');
			const totalSteps = imagesSeason.length;
			const container = document.querySelector('.slider-seasons');
			const heightToScroll = window.innerHeight * 5;
			const buttonsSeason = document.querySelectorAll('.button-season')
			const pageContainer = document.querySelector('.container');

			buttonsSeason.forEach((button, index) => {
				button.addEventListener('click', () => {
					imagesSeason.forEach((image, imageIndex) => {
						if (imageIndex === index) {
							image.classList.add('active');
							gsap.to(image, { opacity: 1, duration: 1 });
						} else {
							image.classList.remove('active');
							gsap.to(image, { opacity: 0, duration: 1 });
						}
					});

					// Update button classes
					buttonsSeason.forEach((otherButton, buttonIndex) => {
						if (buttonIndex === index) {
							otherButton.classList.add('active');
						} else {
							otherButton.classList.remove('active');
						}

						// If the first button is active, add 'first' class to all buttons and '#text-discover'
						if (index === 0) {
							otherButton.classList.add('first');
							document.getElementById("text-discover").classList.add('first');
						} else {
							otherButton.classList.remove('first');
							document.getElementById("text-discover").classList.remove('first');
						}
					});

					// Get the current step
					const currentStep = Math.round(tlImage.scrollTrigger.progress() * totalSteps);

					// Calculate the scroll position
					const scrollPosition = index * window.innerHeight - currentStep * window.innerHeight;

					// Simulate scroll
					window.scrollTo({
						top: scrollPosition,
						behavior: 'smooth'
					});
				});
			});
		
			ScrollTrigger.create({
				scroller: pageContainer,
				trigger: container,
				start: "top top",
				end: `+=${heightToScroll} `,
				pin: true,
				pinSpacing: true,
				scrub: 0.5,
			});


			const tlImage = gsap.timeline({
				scrollTrigger: {
					scroller: pageContainer,
					trigger: container,
					start: "top top",
					end: `+=${window.innerHeight * 4}`,
					scrub: true,
				}
			});
			tlImage.fromTo(imagesSeason[0], { opacity: 1 }, {
				opacity: 1, duration: 1
			}, "0")
				.to(imagesSeason[0], {
					opacity: 0, duration: 1, onComplete: function () {
						buttonsSeason[0].classList.remove('active');
						buttonsSeason[1].classList.add('active');
						document.getElementById("text-discover").classList.remove('first')
						buttonsSeason.forEach((button) => {
							button.classList.remove('first')
						})
					}, onReverseComplete: function () {
						buttonsSeason[1].classList.remove('active');
						buttonsSeason[0].classList.add('active');
						buttonsSeason.forEach((button) => {
							button.classList.add('first')
						})
						document.getElementById("text-discover").classList.add('first')
					}
				}, window.innerHeight);

			tlImage.fromTo(imagesSeason[1], { opacity: 0 }, {
				opacity: 1, duration: 1
			}, window.innerHeight)
				.to(imagesSeason[1], {
					opacity: 0, duration: 1, onComplete: function () {
						buttonsSeason[1].classList.remove('active');
						buttonsSeason[2].classList.add('active');
					}, onReverseComplete: function () {
						buttonsSeason[2].classList.remove('active');
						buttonsSeason[1].classList.add('active');
					}
				}, window.innerHeight * 2);

			tlImage.fromTo(imagesSeason[2], { opacity: 0 }, {
				opacity: 1, duration: 1
			}, window.innerHeight * 2)
				.to(imagesSeason[2], {
					opacity: 0, duration: 1, onComplete: function () {
						buttonsSeason[2].classList.remove('active');
						buttonsSeason[3].classList.add('active');
					}, onReverseComplete: function () {
						buttonsSeason[3].classList.remove('active');
						buttonsSeason[2].classList.add('active');
					}
				}, window.innerHeight * 3);

			tlImage.fromTo(imagesSeason[3], { opacity: 0 }, {
				opacity: 1, duration: 1
			}, window.innerHeight * 3);
		}

		if (document.querySelector(".pin-wrapBis")) {


			if (window.innerWidth > 1024) {

				let pinWrap = document.querySelector(".pin-wrapBis");
				let pinWrapWidth = pinWrap.offsetWidth;
				let horizontalScrollLength = pinWrapWidth - window.innerWidth;
				console.log("here", pinWrapWidth, window.innerWidth, horizontalScrollLength)
				// Pinning and horizontal scrolling
				gsap.to(".pin-wrapBis", {
					scrollTrigger: {
						scroller: pageContainer, // locomotive-scroll
						scrub: 0.5,
						trigger: "#sectionPin2",
						pin: true,
						start: "top top",
						end: () => `+=${pinWrapWidth}`,
					},
					x: -horizontalScrollLength,
					ease: "none",
				});
			}
		}


		if (document.querySelector(".abeille-start")) {
			let imagesSlider = document.querySelectorAll('.slider-diag-content img')


			let animation = gsap.fromTo(imagesSlider[1],
				{ left: "100%", top: "50%" },
				{
					left: "-5%", top: "25%",
					duration: 1,
					ease: "SlowMo.ease",
					paused: true // Pause the animation initially
				}
			);
			ScrollTrigger.create({
				scroller: pageContainer, // locomotive-scroll
				trigger: "#abeille-start",
				pin: true,
				start: "top top", // start after scrolling 50vh
				end: "+=100%", // keep the section pinned for 300%
				onEnter: () => {
					gsap.to(document.querySelector('.bee-part .bee-element'), { left: '100%', duration: 6, ease: "SlowMo.ease" });
				},
				onLeaveBack: () => {
					gsap.to(document.querySelector('.bee-part .bee-element'), { left: '-200px', duration: 6, ease: "SlowMo.ease" });

				}
			});

		}

		if (document.querySelector(".text-slider-section")) {
			let imagesSlider = document.querySelectorAll('.slider-diag-content img')


			let animation = gsap.fromTo(imagesSlider[1],
				{ left: "100%", top: "50%" },
				{
					left: "-5%", top: "25%",
					duration: 1,
					ease: "SlowMo.ease",
					paused: true // Pause the animation initially
				}
			);
			ScrollTrigger.create({
				scroller: pageContainer, // locomotive-scroll
				trigger: "#text-slider-section-pin",
				pin: true,
				start: "top top", // start after scrolling 50vh
				end: "+=250%", // keep the section pinned for 300%
				onEnter: () => {
					animation.play();
					gsap.to(document.querySelector('.bee-part .bee-element'), { left: '100%', duration: 6, ease: "SlowMo.ease" });
				},
				onLeaveBack: () => {
					animation.reverse();
					gsap.to(document.querySelector('.bee-part .bee-element'), { left: '-200px', duration: 6, ease: "SlowMo.ease" });

				}
			});
		}

		////////////////////////////////////
		scroller.on("call", (value) => {
			if (value === "test") {
				if (window.innerWidth < 576) {
					if (document.querySelector(".imgPileElement:last-of-type").classList.contains("is-inview")) {
						document.getElementById("imgPile-text-first").classList.remove("hide");
					}
				}
			} else if (value === "video-border-block") {
				document.querySelector(".video-border-background .border-animation").classList.add("animate");
			} else if (value === "video-border-block-back") {
				document.querySelector(".video-border-background .border-animation").classList.remove("animate");
			}
		});

		ScrollTrigger.refresh()
	}
	const nav = document.querySelector("nav");
	const navSmall = document.querySelector(".navigation-small");
	const navExpanded = document.querySelector(".navigation-expanded");
	///////////// NAVIGATION //////////////
	if (document.querySelector("nav")) {


		let navExpandedhover;
		let closeNavTimeout;
		let hoverTimeout;

		// Ajouter un écouteur d'événement pour le défilement
		document.addEventListener('scroll', function () {
                //console.log('Close nav');
                navExpandedhover = false;
		    	closeNav();
		});
		document.addEventListener('click', function (event) {
            if (!navExpanded.contains(event.target)&&!navSmall.contains(event.target)) {
                //console.log('Clicked outside navExpanded');
                navExpandedhover = false;
                closeNav();
            }

        });

		navExpanded.addEventListener("mouseenter", function () {
				navExpandedhover = true;
				clearTimeout(closeNavTimeout); // Cancel the closing if mouse enters navExpanded
			
		});

		/*
		navExpanded.addEventListener("mouseleave", function () {
			hoverTimeout = setTimeout(function () {
				navExpandedhover = false;
				closeNav();
			}, 5000);
		});
		*/
		

		function openNav() {
		    nav.classList.add("open");
		    setTimeout(function () {
		        navExpanded.classList.add("open");
		    }, 10);
		}
		['mouseenter', 'touchstart'].forEach(eventType => {
		    navSmall.addEventListener(eventType, openNav);
		});

		/*
		navSmall.addEventListener("mouseenter", function () {
			nav.classList.add("open");
			setTimeout(function () {
				navExpanded.classList.add("open");
			}, 10);
		});
		*/
		/*
		navSmall.addEventListener("mouseleave", function () {
			//closeNav();
		});
		*/

		function closeNav() {
			closeNavTimeout = setTimeout(function () {
				if (!navExpandedhover) { // Only close if mouse is not over navExpanded
					nav.classList.remove("open");
					navExpanded.classList.remove("open");
				}
			}, 10);
		}
	}

	if (document.querySelector("#popin-allvideos")) {
		var popin_allvideos = document.getElementById('popin-allvideos');
	    
	    /*
	    var openPopin_allvideos = document.getElementById('open-popin-allvideos');
	    openPopin_allvideos.onclick = function(event) {
	        event.preventDefault(); // Empêche le comportement par défaut du lien
	        popin_allvideos.style.display = 'block';
	        setTimeout(() => {
				popin_allvideos.style.opacity = 1; // Show the popin
			}, 10)
	    }
	    */

	    var openPopin_allvideos_class = document.querySelectorAll('.open-popin-allvideos');
	    openPopin_allvideos_class.forEach(function (buttonOpen) {
		    buttonOpen.addEventListener('click', function () {
		        event.preventDefault(); // Empêche le comportement par défaut du lien
		        popin_allvideos.style.display = 'block';
		        setTimeout(() => {
					popin_allvideos.style.opacity = 1; // Show the popin
				}, 10);
		    });
	    });

	    var popinCloseButtons = document.querySelectorAll('.popin-close-allvideos');
		popinCloseButtons.forEach(function (button) {
		    button.addEventListener('click', function () {
		        setTimeout(function () {
	                popin_allvideos.style.display = 'none'; // Masque complètement la popin après la transition
	            }, 1000);
		        popin_allvideos.style.opacity = 0;
		    });
		});
	}

	if (document.querySelector("#allHouses")) {
		var areas = document.querySelectorAll('#allHouses circle');
		var houseImage = document.querySelector('.house-zone');
		areas.forEach(function (area) {

			if (window.innerWidth > 1024) {
				area.addEventListener('mouseover', function () {
					var houseNumber = this.dataset.index; // Get the house number from the data-index attribute
					houseImage.src = '/wp-content/themes/hds_theme/assets/img/content/house' + houseNumber + '.jpg'; // Change the image source
					houseImage.style.opacity = 1; // Set the opacity to 1
				});

				area.addEventListener('mouseout', function () {
					houseImage.src = ''; // Remove the image source when not hovering
				});
			}

			area.addEventListener('click', function (event) {
				event.preventDefault(); // Prevent the default action (navigation)
				var houseNumber = this.dataset.index; // Get the house number from the data-index attribute
				var popin = document.getElementById('popin-house-' + houseNumber); // Get the corresponding popin
				popin.style.display = 'block'; // Show the popin
				setTimeout(() => {
					popin.style.opacity = 1; // Show the popin
				}, 10);
				//playFondSound("8");

			});
			var popinCloseButtons = document.querySelectorAll('.popin-house .popin-close');

			popinCloseButtons.forEach(function (button) {
			    button.addEventListener('click', function () {
			        // On remonte jusqu'à l'élément parent avec la classe 'popin-house' pour ce bouton
			        var popinHouse = button.closest('.popin-house');
			        
			        if (popinHouse) {
			            popinHouse.style.opacity = 0; // Cache la popin avec une transition d'opacité
			            setTimeout(function () {
			                popinHouse.style.display = 'none'; // Masque complètement la popin après la transition
			            }, 1000);
			        }
			    });
			});
		});
	}


	// Sélectionnez les éléments que vous souhaitez observer
	const target0 = document.getElementById('videobg-intro');
	const target1 = document.getElementById('pin-item-1');
	const target2 = document.getElementById('image-sequence');

	const target3 = document.getElementById('goHouses');
	const target4 = document.getElementById('goHome');
	const target5 = document.getElementById('goContact');
	const target6 = document.getElementById('goExperiences');

	const target7 = document.getElementById('pin-item-1');
	const target8 = document.getElementById('pin-item-2');
	const target9 = document.getElementById('pin-voiture');
	const target10 = document.getElementById('pin-people');
	const target11 = document.getElementById('houses-section');
	const target12 = document.getElementById('son-logo');
	const target13 = document.getElementById('allHouses');
	const target14 = document.getElementById('experiences-section');

	// Créez une fonction de callback pour l'observateur
	const callback = (entries, observer) => {
	    entries.forEach(entry => {
	        if (entry.isIntersecting) {
	            // Vérifiez quel élément est visible et appelez la fonction correspondante
	            if (entry.target.id === 'videobg-intro') {
	                var videoBgIntro = document.getElementById('videobg-intro');
	                if(videoBgIntro.paused){
	                	videoBgIntro.play();
	                }
	            }
	            if (entry.target.id === 'pin-item-1') {
	              
	                //console.log("pin-item-1");
	                //stopAllMedia();
	                var videoBgIntro = document.getElementById('videobg-intro');
	                videoBgIntro.pause();
	              	playFondSound("1");
	                // Si vous ne souhaitez observer qu'une seule fois, vous pouvez arrêter l'observation
	                //observer.unobserve(entry.target);
	            
	            } else if (entry.target.id === 'image-sequence') {
	              
	              	//console.log("image-sequence");
	              	playFondSound("10");
	              	observer.unobserve(entry.target);

	            } 
	            else if (entry.target.id === 'goHouses') {

	            	playFondSound("7");

	                // Appelez une autre fonction pour cet élément
	               	
	            	/*
	               	var section = document.getElementById('goHouses');
	                if (section) {
	                	var langExtension = section.dataset.lang;
	                	nav.classList.add("open");
						setTimeout(function () {
							navExpanded.classList.add("open");
						}, 10);
    					setTimeout(() => {
							window.location.href = '/'+langExtension+'/'+langExtension+'-les-maisons/';
						}, 3000); // 2 seconds timeout
	                	//observer.unobserve(entry.target);
	                }
	                */
	            }
	            else if (entry.target.id === 'goHome') {
	                // Appelez une autre fonction pour cet élément
	                var section = document.getElementById('goHome');
	                if (section) {
	                	var langExtension = section.dataset.lang;
	                	nav.classList.add("open");
						setTimeout(function () {
							navExpanded.classList.add("open");
						}, 10);
    					setTimeout(() => {
							window.location.href = '/?lang='+langExtension+'';
						}, 2000); // 2 seconds timeout
	                	//observer.unobserve(entry.target);
	                }
	            }
	            else if (entry.target.id === 'goContact') {
	                // Appelez une autre fonction pour cet élément
	                var section = document.getElementById('goContact');
	                nav.classList.add("open");
						setTimeout(function () {
							navExpanded.classList.add("open");
						}, 10);
	                if (section) {
	                	var langExtension = section.dataset.lang;
    					setTimeout(() => {
							window.location.href = '/'+langExtension+'/'+langExtension+'-contact/';
						}, 2000); // 2 seconds timeout
	                	//observer.unobserve(entry.target);
	                }
	            }
	            else if (entry.target.id === 'allHouses') {
	                playFondSound("8");
	            }
	            else if (entry.target.id === 'experiences-section') {
	            	playFondSound("8");
	            	var videoExp = document.getElementById('experiencesVideo');
			        var videoSourceExp = document.getElementById('experiencesSource');
			        videoSourceExp.src = '/wp-content/themes/hds_theme/assets/video/experiences.mp4'; // Assurez-vous que le chemin est correct
			        videoExp.load();
			        videoExp.muted = false; // Désactiver le mode muet
			        videoExp.play().then(() => {
			        }).catch(error => {
			        });
			    }
	            else if (entry.target.id === 'goExperiences') {
	                // Appelez une autre fonction pour cet élément
	                
	                playFondSound("9");
	                /*
	                var section = document.getElementById('goExperiences');
	                nav.classList.add("open");
						setTimeout(function () {
							navExpanded.classList.add("open");
						}, 10);
	                if (section) {
	                	var langExtension = section.dataset.lang;
    					setTimeout(() => {
							window.location.href = '/'+langExtension+'/'+langExtension+'-experiences-nature/';
						}, 2000); // 2 seconds timeout
	                	//observer.unobserve(entry.target);
	                }
	                */
	            }
	            else if (entry.target.id === 'pin-item-2') {
	              
	              	//console.log("image-sequence");
	              	playFondSound("2");
	              	//observer.unobserve(entry.target);

	            }
	            else if (entry.target.id === 'pin-voiture') {
	              
	              	//console.log("image-sequence");
	              	//playFondSound("3");
	              	playFondSound("4X4");
	            	
	              	var video4 = document.getElementById('video4x4');
	                var langExtension = video4.dataset.lang;
			        var videoSource4 = document.getElementById('video4x4_source');
			        videoSource4.src = '/wp-content/themes/hds_theme/assets/video/MASTER_SHORT_4X4_'+langExtension+'.mp4'; // Assurez-vous que le chemin est correct
			        video4.load();
			        video4.muted = false; // Désactiver le mode muet
			        video4.play().then(() => {
			            console.log('La vidéo 44 est activée avec le son.');
			        }).catch(error => {
			            console.error('Erreur lors de la lecture de la vidéo 44 :', error);
			        });

			        /*
			        video4.addEventListener('ended', function() {
					    // Définissez la quantité de défilement souhaitée en pixels
					    const scrollAmount = 200; // Par exemple, 200 pixels
					    // Faites défiler la page de la quantité spécifiée
					    window.scrollBy({
					      top: scrollAmount,
					      left: 0,
					      behavior: 'smooth' // Utilisez 'smooth' pour un défilement fluide
					    });
					});
					*/

	              	//observer.unobserve(entry.target);
	            }
	            else if (entry.target.id === 'pin-people') {
	              
	              	//console.log("image-sequence");
	              	playFondSound("4");
	              	//observer.unobserve(entry.target);

	            }
	            else if (entry.target.id === 'houses-section') {
	              
	              	//console.log("image-sequence");
	              	playFondSound("5");
	              	//observer.unobserve(entry.target);

	            }
	            else if (entry.target.id === 'son-logo') {
	              
	              	//console.log("image-sequence");
	              	playFondSound("6");
	              	//observer.unobserve(entry.target);

	            }
	        }
	    });
	};

	// Créez une instance de l'Intersection Observer
	const observer = new IntersectionObserver(callback, {
	    root: null, // Utilisez le viewport comme conteneur racine
	    rootMargin: '0px',
	    threshold: 0.6 // Déclenchement lorsque 10% de la div est visible
	});

	// Commencez à observer les éléments cibles

	if (document.querySelector("#videobg-intro")) { observer.observe(target0); }
	if (document.querySelector("#pin-item-1")) { observer.observe(target1); }
	if (document.querySelector("#image-sequence")) { observer.observe(target2); }

	if (document.querySelector("#goHouses")) { observer.observe(target3); }
	if (document.querySelector("#goHome")) { observer.observe(target4); }
	if (document.querySelector("#goContact")) { observer.observe(target5); }
	if (document.querySelector("#goExperiences")) { observer.observe(target6); }

	//if (document.querySelector("#pin-item-1")) { observer.observe(target7); }
	if (document.querySelector("#pin-item-2")) { observer.observe(target8); }
	if (document.querySelector("#pin-voiture")) { observer.observe(target9); }
	if (document.querySelector("#pin-people")) { observer.observe(target10); }
	if (document.querySelector("#houses-section")) { observer.observe(target11); }
	if (document.querySelector("#son-logo")) { observer.observe(target12); }
	if (document.querySelector("#allHouses")) { observer.observe(target13); }
	if (document.querySelector("#experiences-section")) { observer.observe(target14); }
});
// ... existing code ...
window.addEventListener('unload', function () {
	ScrollTrigger.getAll().forEach(ST => {
		if (ST.pin) {
			ST.unpin();
		}
		ST.kill();
	});
	scroller.destroy();
});

document.addEventListener('DOMContentLoaded', function() {
	document.getElementById('enableSound').addEventListener('click', function() {
	    var audiobg = document.getElementById('background-audio-bg');
	    document.getElementById('enableSound').style.display = 'none';
	    // Jouer et mettre en pause immédiatement pour "déverrouiller" le son
	    audiobg.play().then(() => {
	        audiobg.pause();
	        audiobg.currentTime = 0; // Réinitialiser le temps de lecture
	        console.log('Le son est activé et prêt à être joué.');
	    }).catch(error => {
	        console.error('Erreur lors de l\'activation du son :', error);
	    });

	    var video = document.getElementById('videobg-intro');
        var videoSource = document.getElementById('videobg-intro-source');
        videoSource.src = '/wp-content/themes/hds_theme/assets/video/header-sound.mp4'; // Assurez-vous que le chemin est correct
        video.load();
        video.muted = false; // Désactiver le mode muet
        video.play().then(() => {
            console.log('La vidéo est activée avec le son.');
        }).catch(error => {
            console.error('Erreur lors de la lecture de la vidéo :', error);
        });

	});

	if (window.innerWidth > 1020) {
		var video1intro = document.getElementById('videobg-intro');
	    // Ajoute un écouteur d'événement pour l'événement 'ended'
	    video1intro.addEventListener('ended', function() {
	        // Sélectionne la div cachée
	        var hiddenDiv = document.getElementById('scroll-msg-id');
	        // Change le style pour l'afficher
	        hiddenDiv.style.display = 'block';
	    });

	    var video24x4 = document.getElementById('video4x4');
	    // Ajoute un écouteur d'événement pour l'événement 'ended'
	    video24x4.addEventListener('ended', function() {
	        // Sélectionne la div cachée
	        var hiddenDiv = document.getElementById('scroll-msg-id2');
	        // Change le style pour l'afficher
	        hiddenDiv.style.display = 'block';
	    });

	    var video3exêrience = document.getElementById('experiencesVideo');
	    // Ajoute un écouteur d'événement pour l'événement 'ended'
	    video24x4.addEventListener('ended', function() {
	        // Sélectionne la div cachée
	        var hiddenDiv = document.getElementById('scroll-msg-id3');
	        // Change le style pour l'afficher
	        hiddenDiv.style.display = 'block';
	    });
    }
});

/*
function stopAllMedia() {
        // Sélectionner tous les éléments audio et vidéo
        const mediaElements = document.querySelectorAll('audio, video');
        // Mettre en pause chaque élément
        mediaElements.forEach(media => {
            media.pause();
            media.currentTime = 0; // Réinitialiser à la position de départ si nécessaire
        });
}*/

function playFondSound(filename) {
      document.getElementById('audio-source-bg').src = '/wp-content/themes/hds_theme/assets/mp3/'+filename+'.mp3';
      var audioElementBg = document.getElementById('background-audio-bg');
      audioElementBg.load();
            // Assurez-vous que l'audio ne boucle pas
      audioElementBg.loop = false;
            // Accélérer la lecture de l'audio (par exemple, 1.5x la vitesse normale)
            //audioElement2.playbackRate = 1.25;
            // Jouer l'audio
      audioElementBg.volume = 1.0;
      audioElementBg.play(); 
}

function stopVideoIntro() {
    // Sélectionner tous les éléments audio et vidéo
    //const mediaElements = document.querySelectorAll('audio, video');
    const mediaElements = document.querySelectorAll('audio#videobg-intro-source');
    //const mediaElements = document.getElementById('background-audio');

    // Mettre en pause chaque élément avec un fondu sonore
    mediaElements.forEach(media => {
        // Définir la durée du fondu en millisecondes
        const fadeDuration = 1000; // 1 seconde
        const fadeInterval = 50; // Intervalle de temps entre chaque réduction de volume
        const fadeStep = media.volume / (fadeDuration / fadeInterval);

        // Fonction pour réduire le volume progressivement
        const fadeAudio = setInterval(() => {
            if (media.volume > fadeStep) {
                media.volume -= fadeStep;
            } else {
                media.volume = 0;
                media.pause();
                media.currentTime = 0; // Réinitialiser à la position de départ si nécessaire
                clearInterval(fadeAudio);
            }
        }, fadeInterval);
    });
}

function stopAllMedia() {
    // Sélectionner tous les éléments audio et vidéo
    //const mediaElements = document.querySelectorAll('audio, video');
    const mediaElements = document.querySelectorAll('audio');
    //const mediaElements = document.getElementById('background-audio');

    // Mettre en pause chaque élément avec un fondu sonore
    mediaElements.forEach(media => {
        // Définir la durée du fondu en millisecondes
        const fadeDuration = 1000; // 1 seconde
        const fadeInterval = 50; // Intervalle de temps entre chaque réduction de volume
        const fadeStep = media.volume / (fadeDuration / fadeInterval);

        // Fonction pour réduire le volume progressivement
        const fadeAudio = setInterval(() => {
            if (media.volume > fadeStep) {
                media.volume -= fadeStep;
            } else {
                media.volume = 0;
                media.pause();
                media.currentTime = 0; // Réinitialiser à la position de départ si nécessaire
                clearInterval(fadeAudio);
            }
        }, fadeInterval);
    });
}
